import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { UserService, BaseComponent, CheckoutService, ContentService } from "@mypxplat/xplat/core";
import { AppService } from "@mypxplat/xplat/web/core";

@Component({
  selector: "myp-checkout-product-details",
  templateUrl: "checkout-product-details.component.html",
  standalone: false,
})
export class CheckoutProductDetailsComponent extends BaseComponent implements OnInit {
  private _productDetails: any;
  @Input()
  set productDetails(productDetails: any) {
    this._productDetails = productDetails;
    if (productDetails?.image) this.defaultImage = productDetails?.image;
  }

  get productDetails(): any {
    return this._productDetails;
  }

  private _coupon: string;
  @Input()
  set coupon(code) {
    // this.checkoutService.getCouponCode(code).subscribe((res) => {
    //   console.log(res);
    // });
    this._coupon = code;
  }

  get coupon() {
    return this._coupon;
  }
  @Input() public defaultImage: string;
  @Input() public loadingPrices: boolean;
  @Input() public totalTaxable: number;

  constructor(
    public userService: UserService,
    public checkoutService: CheckoutService,
    public appService: AppService,
    public contentService: ContentService
  ) {
    super(userService);
  }

  ngOnInit(): void {
    if (!this.defaultImage) {
      if (this.productDetails?.image) {
        this.defaultImage = this.productDetails?.image;
      } else {
        this.defaultImage = this.contentService.logos[this.appService.app][this.appService.activeTheme].dawBoxScreen;
      }
    }
  }
}
